import React from "react";
import { IRootState } from "../../../types/redux/IRootStore";
import { PalletDetail } from "../../../types/palletDetail";
import { AplParameter } from "../../../types/aplParameter";
import { parseBool } from "../../../aplUtils/extensions";
import { getParamByTypeNumber } from "../../../aplUtils/aplParametersHelper";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../redux/hooks";
import { closeModalRedux as closeModal, setModalPallets, setModified } from "../../../redux/slices/modalPallets2.feature";
import { updatePalletsReduxCache } from "../../../redux/slices/palletCache.feature";
import { translateString } from "../../../translations/gridTranslationHelper";
import AplSettingsSelector from "../../../redux/helpers/AplSettingsSelector";
import ModalDefects2BlockedStatusWarning from "./ModalDefects2BlockedStatusWarning";
import ModalDefects2PalletsDisplay from "./ModalDefects2PalletsDisplay";

export default function ModalRelease2() {
    const modalPallets2Redux = useSelector((state: IRootState) => state.modalPallets2);
    const dispatch = useAppDispatch();

    const aplSettings = AplSettingsSelector();
    const modalAplParameters = useSelector((state: IRootState) => state.auth.aplParameters);
    const showCommentBox = parseBool(getParamByTypeNumber(modalAplParameters, aplSettings.siteId, AplParameter.ShowCommentDelete));
    const commentBoxRef = React.useRef() as React.MutableRefObject<HTMLInputElement>;
    const handleCommentUpdate = (e: React.ChangeEvent<HTMLInputElement>, dataKey: string) => {
        let pallets: PalletDetail[] = JSON.parse(JSON.stringify(modalPallets2Redux.pallets));
        pallets.map(x => (x.palletUpdateComment = e.target.value));
        dispatch(setModalPallets(pallets));
        dispatch(setModified(true));
    };

    const handleYes = async () => {
        if (showCommentBox && commentBoxRef.current.value.trim().length === 0) {
            commentBoxRef.current.className = "modalReason form-control is-invalid";
            return;
        }
        dispatch(setModified(true));
        let data = modalPallets2Redux.pallets.map(x => ({ ...x, statusId: 4 }));
        dispatch(updatePalletsReduxCache(data) as any);
    };

    return (
        <React.Fragment>
            <div className="modal-header">
                <h5>{translateString("unblock", aplSettings.culture)}</h5>
                <button
                    type="button"
                    className="close"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    <span aria-hidden="true" className="text-danger">
                        ×
                    </span>
                    <span className="sr-only">Close</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="overflow-none" style={{ maxHeight: "40rem" }} id="modal-overflow">
                    {modalPallets2Redux.message && (
                        <div className="alert alert-danger" role="alert">
                            {modalPallets2Redux.message}
                        </div>
                    )}
                    {!modalPallets2Redux.error && (
                        <ModalDefects2BlockedStatusWarning
                            isUsSite={aplSettings.isUsSite}
                            siteId={aplSettings.siteId}
                            pallets={modalPallets2Redux.pallets}
                        />
                    )}
                    <ModalDefects2PalletsDisplay pallets={modalPallets2Redux.pallets} siteId={aplSettings.siteId} />
                    {showCommentBox ? (
                        <div className="mt-3">
                            <div className="modalComment">
                                <div id="modalComment" style={{ display: "block" }}>
                                    <label htmlFor="modalDialogReason">Comment</label>
                                    <input
                                        name="palletUpdateComment"
                                        type="text"
                                        id="palletUpdateComment"
                                        maxLength={255}
                                        className="modalReason form-control"
                                        onChange={handleCommentUpdate as any}
                                        ref={commentBoxRef}
                                    />
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                        dispatch(closeModal());
                    }}
                >
                    {translateString("close", aplSettings.culture)}
                </button>
                <button type="button" className="btn btn-primary" onClick={handleYes}>
                    {translateString("inBoundBtnOk", aplSettings.culture)}
                </button>
            </div>
        </React.Fragment>
    );
}
